import * as styles from "./page-manager.module.scss";
import { childrenShowingClass } from "./selectorHelpers.js";

const showingClass = styles.isShowing;
const hiddenClass = styles.isHidden;

/**
 * Toggle the visibility of the row
 *
 * @param row The row to toggle
 */
export function toggleRowVisibility(row: HTMLElement): void {
	const showing = row.classList.contains(showingClass);
	if (showing) {
		hideRow(row);
	} else {
		showRow(row);
	}
}

/**
 * Hide the row
 *
 * @param row The row to hide
 */
export function hideRow(row: HTMLElement): void {
	row.classList.remove(showingClass);
	row.classList.add(hiddenClass);
	row.classList.remove(childrenShowingClass);
}

/**
 * Show the row
 *
 * @param row The row to show
 */
export function showRow(row: HTMLElement): void {
	row.classList.remove(hiddenClass);
	row.classList.add(showingClass);
}
